import { Component, OnInit, ViewContainerRef } from '@angular/core'
import { NzModalService } from 'ng-zorro-antd/modal'
import { QueryTableLeave } from 'src/app/services/interface/general.model'
import { NzTableQueryParams } from 'ng-zorro-antd/table'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { NzNotificationService } from 'ng-zorro-antd/notification'
import { NzButtonSize } from 'ng-zorro-antd/button'
import { LeaveManagementService } from 'src/app/services/leave-management/leave-management.service'
import { AnnualLeaveType } from 'src/app/services/interface/leave-management/leave.model'
import { ViewDetailAnnualLeaveComponent } from '../view-detail-annual-leave/view-detail-annual-leave.component'

@Component({
  selector: 'app-tab-approved-annual-leave',
  templateUrl: './tab-approved-annual-leave.component.html',
  //   styleUrls: ['./annual-leave.component.scss'],
})
export class TabApprovedAnnualLeaveComponent implements OnInit {
  form: FormGroup
  isAnnualLeave = true
  selectedFilter = 'APPROVED'
  selectedType = 'Annual Leave'

  listOfData: AnnualLeaveType[] = []

  isLoading: boolean = true
  totalData: number = 0
  pageSize: number = 5
  pageIndex: number = 1

  constructor(
    private fb: FormBuilder,
    private leaveManagementService: LeaveManagementService,
    private modal: NzModalService,
    private notification: NzNotificationService,
    private viewContainerRef: ViewContainerRef,
  ) {
    this.form = this.fb.group({
      keyword: [null, Validators.compose([Validators.required])],
      prefix: ['vendor', Validators.compose([Validators.required])],
    })
  }

  queryTable: QueryTableLeave = {
    sort: { field: null, order: null },
    annual_leave: true,
    pageSize: this.pageSize,
    pageIndex: this.pageIndex - 1,
  }

  listOfColumns = [
    {
      name: 'ID',
      key: 'id',
      sortOrder: null,
      sortFn: null,
      listOfFilter: [],
      filterFn: null,
      left: true,
      right: false,
      width: '30px',
    },
    {
      name: 'Actions',
      key: 'actions',
      sortOrder: null,
      sortFn: null,
      listOfFilter: [],
      filterFn: null,
      left: true,
      right: false,
      width: '25px',
    },
    {
      name: 'Total Leave',
      key: 'total_leave',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '40px',
    },
    {
      name: 'Status',
      key: 'status',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '30px',
    },
    {
      name: 'Date of Leave',
      key: 'date',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '60px',
    },
    {
      name: 'Date of In',
      key: 'join_date',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '35px',
    },
    {
      name: 'Reason',
      key: 'reason',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '50px',
    },
    {
      name: 'Notes',
      key: 'notes_approval',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '50px',
    },
  ]

  ngOnInit(): void {
    // this.fetchAnnualLeaveList()
  }

  fetchAnnualLeaveList() {
    this.isLoading = true
    this.leaveManagementService
      .getAnnualLeaveList(
        this.selectedFilter,
        this.queryTable,
        this.isAnnualLeave,
        this.selectedType,
      )
      .subscribe(
        (r: any) => {
          this.isLoading = false
          // this.listOfData = r.rows
          this.listOfData = r.rows.map((item: any) => ({
            ...item,
            status: this.transformStatus(item.status),
          }))
          this.totalData = r.count
        },
        (error: any) => {
          this.isLoading = false
        },
      ),
      err => {
        this.fetchAnnualLeaveList()
      }
  }

  transformStatus(status: string): string {
    switch (status) {
      // case 'WAITING':
      //   return 'Waiting for Approval'
      case 'CANCELED':
        return 'Canceled'
      case 'APPROVED':
        return 'Approved'
      default:
        return status
    }
  }

  viewDetailLeave(leaveId: string) {
    const modal = this.modal.create({
      nzTitle: 'View Detail Annual Leave',
      nzContent: ViewDetailAnnualLeaveComponent,
      nzStyle: { top: '50px' },
      nzViewContainerRef: this.viewContainerRef,
      nzComponentParams: {
        leaveId: leaveId,
      },
      nzMaskClosable: false,
      nzFooter: [
        {
          label: 'Close',
          danger: true,
          onClick() {
            modal.destroy()
          },
        },
      ],
      nzWidth: '75%',
    })
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort } = params
    this.queryTable.pageSize = pageSize
    this.queryTable.pageIndex = pageIndex - 1
    const currentSort = sort.find(item => item.value !== null)
    const sortField = (currentSort && currentSort.key) || null
    const sortOrder = (currentSort && currentSort.value) || null

    if (sortField != null && sortOrder != null) {
      this.queryTable.sort = {
        field: sortField,
        order: sortOrder,
      }
    } else {
      this.queryTable.sort = { field: null, order: null }
    }
    this.fetchAnnualLeaveList()
  }
}
